import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-who-we-are',
  imports: [TranslateModule, RouterLink, NzIconModule],
  templateUrl: './who-we-are.component.html',
  styleUrl: './who-we-are.component.scss',
})
export class WhoWeAreComponent {
  backLink: string[] = ['..'];
  protected starterString: string = 'whoWeAre';

  constructor(private dataService: DataService) {
    this.dataService.companyId$.subscribe((companyId) => {
      if (companyId) {
        const isFasdac = companyId === '45C41017';
        this.starterString = isFasdac ? 'whoWeAreFasdac' : 'whoWeAre';
      }
    });
  }
}
